import "./Main.scss";

import { observer } from "mobx-react";
import React from "react";
import { Container } from "src/components";
import { attendanceDomain } from "src/domain";

import Attendance from "./Attendance";
import StudentList from "./StudentList";

const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

const Main = () => {
  // 세로모드에서만 쓰이는 드로어 열림 상태. 세션 한정이라 저장하지 않는다.
  const [isListOpen, setIsListOpen] = React.useState(false);

  React.useEffect(() => {
    // 주기 갱신과 visibilitychange 갱신이 겹치면, 먼저 보낸 요청의 오래된
    // 응답이 나중 응답을 덮어쓸 수 있다. 진행 중이면 건너뛴다.
    let isRefreshing = false;
    const refresh = () => {
      if (isRefreshing) return;
      isRefreshing = true;
      attendanceDomain
        .fetchStudentAttendanceList()
        // 백그라운드 갱신이라 실패해도 화면을 건드리지 않고 다음 주기에 재시도한다.
        .catch(() => undefined)
        .then(() => {
          isRefreshing = false;
        });
    };

    refresh();
    const timer = setInterval(refresh, REFRESH_INTERVAL_MS);

    // 안드로이드 WebView는 화면이 가려지면 타이머를 늦추거나 멈춘다.
    // 다시 보이는 순간 한 번 더 갱신해 오래된 데이터가 남지 않게 한다.
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return (
    <Container>
      <div className="main__page">
        <Attendance onOpenList={() => setIsListOpen(true)} />
        {attendanceDomain.isViewList === "VIEW" && (
          <>
            {isListOpen && (
              <button
                type="button"
                className="student__list--dim"
                aria-label="출석 내역 닫기"
                onClick={() => setIsListOpen(false)}
              />
            )}
            <StudentList isOpen={isListOpen} />
          </>
        )}
      </div>
    </Container>
  );
};

export default observer(Main);
